import request from '@/utils/request'

export function getCancelOrNoShowListApi(query) {
  return request({
    url: '/config-service/v1/policy/cancel-or-noshow',
    method: 'get',
    params: query
  })
}

export function addCancelOrNoShowApi(payload) {
  return request({
    url: '/config-service/v1/policy/cancel-or-noshow',
    method: 'post',
    data: payload
  })
}

export function updateCancelOrNoShowApi(payload) {
  return request({
    url: '/config-service/v1/policy/cancel-or-noshow',
    method: 'put',
    data: payload
  })
}

export function deleteCancelOrNoShowApi(payload) {
  return request({
    url: '/config-service/v1/policy/cancel-or-noshow',
    method: 'delete',
    data: payload
  })
}

